import { guid } from '@/utils/helpers'

const AWARDS_LOGOS_FOLDER_NAME = 'awards-2025-broker-logos'

const COMPANY_NAME = {
  VANTAGE_UK: 'Vantage UK',
  VANTAGE: 'Vantage',
  CFI: 'CFI Financial Group',
  '4XC': '4XC',
  HEADWAY: 'Headway',
  TRADU: 'Tradu',
  FBS: 'FBS',
  IFOREX: 'iForex',
  IFOREX_EUROPE: 'iForex Europe',
  CMC_MARKETS: 'CMC Markets Singapore',
  CMC_CONNECT: 'CMC Connect Asia',
  ROBOFOREX: 'RoboForex',
  FP_MARKETS_LATAM: 'FP Markets (Latam)',
  FP_MARKETS: 'FP Markets',
  ONE_ROYAL: 'OneRoyal',
  DERIV: 'Deriv',
  HANTEC: 'Hantec Financial',
  FOTMARKETS: 'Fotmarkets',
  TICKMILL: 'Tickmill',
  HOLA_PRIME: 'Hola Prime',
  BLUEBERRY: 'Blueberry',
  HOLA_PRIME_MARKETS: 'Hola Prime Markets',
  FUNDED_NEXT: 'FundedNext',
  TRADING_PRO: 'TradingPRO',
  AXI: 'Axi',
  AXI_PRIME: 'AxiPrime',
  ONE_PRIME: 'OnePrime',
  AXCERA: 'Axcera',
  ONE_ZERO: 'oneZero',
  CENTROID: 'Centroid Solutions',
  QUADCODE: 'Quadcode Brokerage Solutions',
  FYNXT: 'FYNXT',
  PAYTIKO: 'Paytiko',
  YOUR_BOURSE: 'Your Bourse'
}

const BRAND_LOGOS = {
  VANTAGE: `${AWARDS_LOGOS_FOLDER_NAME}/vantage.png`,
  CFI: `${AWARDS_LOGOS_FOLDER_NAME}/cfi.png`,
  '4XC': `${AWARDS_LOGOS_FOLDER_NAME}/4xc.png`,
  HEADWAY: `${AWARDS_LOGOS_FOLDER_NAME}/headway.png`,
  TRADU: `${AWARDS_LOGOS_FOLDER_NAME}/tradu.png`,
  FBS: `${AWARDS_LOGOS_FOLDER_NAME}/fbs.png`,
  IFOREX: `${AWARDS_LOGOS_FOLDER_NAME}/iforex.png`,
  IFOREX_EUROPE: `${AWARDS_LOGOS_FOLDER_NAME}/iforexeurope.png`,
  CMC_MARKETS: `${AWARDS_LOGOS_FOLDER_NAME}/cmcm.png`,
  CMC_CONNECT: `${AWARDS_LOGOS_FOLDER_NAME}/cmcc.png`,
  ROBOFOREX: `${AWARDS_LOGOS_FOLDER_NAME}/roboforex.png`,
  FP_MARKETS: `${AWARDS_LOGOS_FOLDER_NAME}/fpmarkets.png`,
  ONE_ROYAL: `${AWARDS_LOGOS_FOLDER_NAME}/oneroyal.png`,
  DERIV: `${AWARDS_LOGOS_FOLDER_NAME}/deriv.png`,
  HANTEC: `${AWARDS_LOGOS_FOLDER_NAME}/hantec.png`,
  FOTMARKETS: `${AWARDS_LOGOS_FOLDER_NAME}/fotmarkets.png`,
  TICKMILL: `${AWARDS_LOGOS_FOLDER_NAME}/tickmill.png`,
  HOLA_PRIME: `${AWARDS_LOGOS_FOLDER_NAME}/holaprime.png`,
  BLUEBERRY: `${AWARDS_LOGOS_FOLDER_NAME}/blueberry.png`,
  HOLA_PRIME_MARKETS: `${AWARDS_LOGOS_FOLDER_NAME}/holaprimem.png`,
  FUNDED_NEXT: `${AWARDS_LOGOS_FOLDER_NAME}/fundednext.png`,
  TRADING_PRO: `${AWARDS_LOGOS_FOLDER_NAME}/tradingpro.png`,
  AXI: `${AWARDS_LOGOS_FOLDER_NAME}/axi.png`,
  AXI_PRIME: `${AWARDS_LOGOS_FOLDER_NAME}/axip.png`,
  ONE_PRIME: `${AWARDS_LOGOS_FOLDER_NAME}/oneprime.png`,
  AXCERA: `${AWARDS_LOGOS_FOLDER_NAME}/axcera.png`,
  ONE_ZERO: `${AWARDS_LOGOS_FOLDER_NAME}/onezero.png`,
  CENTROID: `${AWARDS_LOGOS_FOLDER_NAME}/Centroid.png`,
  QUADCODE: `${AWARDS_LOGOS_FOLDER_NAME}/qc.png`,
  FYNXT: `${AWARDS_LOGOS_FOLDER_NAME}/fynxt.png`,
  PAYTIKO: `${AWARDS_LOGOS_FOLDER_NAME}/paytiko.png`,
  YOUR_BOURSE: `${AWARDS_LOGOS_FOLDER_NAME}/youbourse.png`
}

const AWARD_CATEGORY = {
  BEST_OVERALL_BROKER: 'Best Overall Broker 2025',
  BEST_TRADING_CONDITIONS: 'Best Trading Conditions 2025',
  BROKER_OF_THE_YEAR: 'Broker Of The Year 2025',
  MOST_INNOVATIVE_BROKER: 'Most Innovative Broker 2025',
  MOST_ESTABLISHED_BROKER: 'Most Established Broker 2025',
  MOST_TRUSTED_BROKER: 'Most Trusted Broker 2025',
  PROP_FIRM_OF_THE_YEAR: 'Prop Firm of the Year 2025',
  MOST_TRANSPARENT_PROP_FIRM: 'Most Transparent Prop Firm 2025',
  BEST_RISING_STAR_BROKER: 'Best Rising Star Broker 2025',
  BEST_SPREADS_BROKER_UK: 'Best Spreads Broker 2025 (UK)',
  BEST_AFFILIATE_PROGRAM_BROKER_UK: 'Best Affiliate Program Broker 2025 (UK)',
  MOST_ESTABLISHED_BROKER_UAE: 'Most Established Broker 2025 (UAE)',
  MOST_TRANSPARENT_BROKER_MEXICO: 'Most Transparent Broker 2025 (Mexico)',
  BEST_OVERALL_BROKER_INDONESIA: 'Best Overall Broker 2025 (Indonesia)',
  BROKER_OF_THE_YEAR_THAILAND: 'Broker of The Year 2025 (Thailand)',
  FASTEST_GROWING_BROKER_VIETNAM: 'Fastest Growing Broker 2025 (Vietnam)',
  BEST_OVERALL_BROKER_ASIA: 'Best Overall Broker 2025 (Asia)',
  MOST_INNOVATIVE_BROKER_ASIA: 'Most Innovative Broker 2025 (Asia)',
  MOST_TRUSTED_BROKER_ASIA: 'Most Trusted Broker 2025 (Asia)',
  BROKER_OF_THE_YEAR_ASIA: 'Broker of the Year 2025 (Asia)',
  MOST_INNOVATIVE_BROKER_EUROPE: 'Most Innovative Broker 2025 (Europe)',
  BROKER_OF_THE_YEAR_LATAM: 'Broker of the year 2025 (LATAM)',
  MOST_INNOVATIVE_BROKER_LATAM: 'Most Innovative Broker 2025 (LATAM)',
  MOST_TRANSPARENT_BROKER_LATAM: 'Most Transparent Broker 2025 (LATAM)',
  BEST_TRADING_EXPERIENCE_BROKER_LATAM:
    'Best Trading Experience Broker 2025 (LATAM)',
  MOST_TRANSPARENT_BROKER_MENA: 'Most Transparent Broker 2025 (MENA)',
  MOST_TRUSTED_BROKER_MENA: 'Most Trusted Broker 2025 (MENA)',
  MOST_INNOVATIVE_BROKER_MENA: 'Most Innovative Broker 2025 (MENA)',
  BROKER_OF_THE_YEAR_AFRICA: 'Broker Of The Year 2025 (Africa)',
  BEST_EXECUTION_BROKER: 'Best Execution Broker 2025',
  BEST_TRADING_INFRASTRUCTURE_PROVIDER:
    'Best Trading Infrastructure Provider 2025',
  BEST_INSTITUTIONAL_LIQUIDITY_SERVICE:
    'Best Institutional Liquidity Service 2025',
  BEST_MULTI_ASSET_TRADING_TECHNOLOGY:
    'Best Multi-Asset Trading Technology 2025',
  BEST_LIQUIDITY_POOL_AGGREGATOR: 'Best Liquidity Pool Aggregator 2025',
  BEST_CONNECTIVITY_TECHNOLOGY: 'Best Connectivity Technology 2025',
  BEST_BROKER_INFRASTRUCTURE_PROVIDER:
    'Best Broker Infrastructure Provider 2025',
  BEST_PROP_TRADING_TECHNOLOGY_PROVIDER:
    'Best Prop Trading Technology Provider 2025',
  BEST_WHITE_LABEL_SOLUTION_FOR_BROKERS:
    'Best White Label Solution for brokers 2025',
  MOST_INNOVATIVE_PAYMENT_ORCHESTRATOR:
    'Most innovative payment orchestrator 2025'
}

export const WINNERS = {
  B2C: {
    National: {
      Brands: [
        {
          Id: `Vantage-${guid()}`,
          Name: COMPANY_NAME.VANTAGE_UK,
          LogoUrl: BRAND_LOGOS.VANTAGE,
          WinningCategory: AWARD_CATEGORY.BEST_AFFILIATE_PROGRAM_BROKER_UK
        },
        {
          Id: `CFI-${guid()}`,
          Name: COMPANY_NAME.CFI,
          LogoUrl: BRAND_LOGOS.CFI,
          WinningCategory: AWARD_CATEGORY.MOST_ESTABLISHED_BROKER_UAE
        },
        {
          Id: `4XC-${guid()}`,
          Name: COMPANY_NAME['4XC'],
          LogoUrl: BRAND_LOGOS['4XC'],
          WinningCategory: AWARD_CATEGORY.MOST_TRANSPARENT_BROKER_MEXICO
        },
        {
          Id: `Headway-${guid()}`,
          Name: COMPANY_NAME.HEADWAY,
          LogoUrl: BRAND_LOGOS.HEADWAY,
          WinningCategory: AWARD_CATEGORY.BEST_OVERALL_BROKER_INDONESIA
        },
        {
          Id: `Tradu-${guid()}`,
          Name: COMPANY_NAME.TRADU,
          LogoUrl: BRAND_LOGOS.TRADU,
          WinningCategory: AWARD_CATEGORY.BEST_SPREADS_BROKER_UK
        },
        {
          Id: `FBS-${guid()}`,
          Name: COMPANY_NAME.FBS,
          LogoUrl: BRAND_LOGOS.FBS,
          WinningCategory: AWARD_CATEGORY.BROKER_OF_THE_YEAR_THAILAND
        },
        {
          Id: `Vantage-${guid()}`,
          Name: COMPANY_NAME.VANTAGE,
          LogoUrl: BRAND_LOGOS.VANTAGE,
          WinningCategory: AWARD_CATEGORY.FASTEST_GROWING_BROKER_VIETNAM
        }
      ]
    },
    Regional: {
      Brands: [
        {
          Id: `iForex-${guid()}`,
          Name: COMPANY_NAME.IFOREX,
          LogoUrl: BRAND_LOGOS.IFOREX,
          WinningCategory: AWARD_CATEGORY.BEST_OVERALL_BROKER_ASIA
        },
        {
          Id: `iForexEurope-${guid()}`,
          Name: COMPANY_NAME.IFOREX_EUROPE,
          LogoUrl: BRAND_LOGOS.IFOREX_EUROPE,
          WinningCategory: AWARD_CATEGORY.MOST_INNOVATIVE_BROKER_EUROPE
        },
        {
          Id: `CMCMarkets-${guid()}`,
          Name: COMPANY_NAME.CMC_MARKETS,
          LogoUrl: BRAND_LOGOS.CMC_MARKETS,
          WinningCategory: AWARD_CATEGORY.MOST_INNOVATIVE_BROKER_ASIA
        },
        {
          Id: `RoboForex-${guid()}`,
          Name: COMPANY_NAME.ROBOFOREX,
          LogoUrl: BRAND_LOGOS.ROBOFOREX,
          WinningCategory: AWARD_CATEGORY.BEST_TRADING_EXPERIENCE_BROKER_LATAM
        },
        {
          Id: `FPMarketsLatam-${guid()}`,
          Name: COMPANY_NAME.FP_MARKETS_LATAM,
          LogoUrl: BRAND_LOGOS.FP_MARKETS,
          WinningCategory: AWARD_CATEGORY.MOST_INNOVATIVE_BROKER_LATAM
        },
        {
          Id: `FPMarkets-${guid()}`,
          Name: COMPANY_NAME.FP_MARKETS,
          LogoUrl: BRAND_LOGOS.FP_MARKETS,
          WinningCategory: AWARD_CATEGORY.BROKER_OF_THE_YEAR_ASIA
        },
        {
          Id: `OneRoyal-${guid()}`,
          Name: COMPANY_NAME.ONE_ROYAL,
          LogoUrl: BRAND_LOGOS.ONE_ROYAL,
          WinningCategory: AWARD_CATEGORY.MOST_INNOVATIVE_BROKER_MENA
        },
        {
          Id: `Headway-${guid()}`,
          Name: COMPANY_NAME.HEADWAY,
          LogoUrl: BRAND_LOGOS.HEADWAY,
          WinningCategory: AWARD_CATEGORY.BROKER_OF_THE_YEAR_AFRICA
        },
        {
          Id: `Deriv-${guid()}`,
          Name: COMPANY_NAME.DERIV,
          LogoUrl: BRAND_LOGOS.DERIV,
          WinningCategory: AWARD_CATEGORY.MOST_TRUSTED_BROKER_MENA
        },
        {
          Id: `Hantec-${guid()}`,
          Name: COMPANY_NAME.HANTEC,
          LogoUrl: BRAND_LOGOS.HANTEC,
          WinningCategory: AWARD_CATEGORY.MOST_TRUSTED_BROKER_ASIA
        },
        {
          Id: `Fotmarkets-${guid()}`,
          Name: COMPANY_NAME.FOTMARKETS,
          LogoUrl: BRAND_LOGOS.FOTMARKETS,
          WinningCategory: AWARD_CATEGORY.MOST_TRANSPARENT_BROKER_LATAM
        },
        {
          Id: `Tickmill-${guid()}`,
          Name: COMPANY_NAME.TICKMILL,
          LogoUrl: BRAND_LOGOS.TICKMILL,
          WinningCategory: AWARD_CATEGORY.BROKER_OF_THE_YEAR_LATAM
        },
        {
          Id: `CFI-${guid()}`,
          Name: COMPANY_NAME.CFI,
          LogoUrl: BRAND_LOGOS.CFI,
          WinningCategory: AWARD_CATEGORY.MOST_TRANSPARENT_BROKER_MENA
        }
      ]
    },
    Global: {
      Brands: [
        {
          Id: `FPMarkets-${guid()}`,
          Name: COMPANY_NAME.FP_MARKETS,
          LogoUrl: BRAND_LOGOS.FP_MARKETS,
          WinningCategory: AWARD_CATEGORY.BROKER_OF_THE_YEAR
        },
        {
          Id: `HolaPrime-${guid()}`,
          Name: COMPANY_NAME.HOLA_PRIME,
          LogoUrl: BRAND_LOGOS.HOLA_PRIME,
          WinningCategory: AWARD_CATEGORY.MOST_TRANSPARENT_PROP_FIRM
        },
        {
          Id: `RoboForex-${guid()}`,
          Name: COMPANY_NAME.ROBOFOREX,
          LogoUrl: BRAND_LOGOS.ROBOFOREX,
          WinningCategory: AWARD_CATEGORY.MOST_TRUSTED_BROKER
        },
        {
          Id: `Blueberry-${guid()}`,
          Name: COMPANY_NAME.BLUEBERRY,
          LogoUrl: BRAND_LOGOS.BLUEBERRY,
          WinningCategory: AWARD_CATEGORY.MOST_ESTABLISHED_BROKER
        },
        {
          Id: `HolaPrimeMarkets-${guid()}`,
          Name: COMPANY_NAME.HOLA_PRIME_MARKETS,
          LogoUrl: BRAND_LOGOS.HOLA_PRIME_MARKETS,
          WinningCategory: AWARD_CATEGORY.BEST_RISING_STAR_BROKER
        },
        {
          Id: `FundedNext-${guid()}`,
          Name: COMPANY_NAME.FUNDED_NEXT,
          LogoUrl: BRAND_LOGOS.FUNDED_NEXT,
          WinningCategory: AWARD_CATEGORY.PROP_FIRM_OF_THE_YEAR
        },
        {
          Id: `TradingPRO-${guid()}`,
          Name: COMPANY_NAME.TRADING_PRO,
          LogoUrl: BRAND_LOGOS.TRADING_PRO,
          WinningCategory: AWARD_CATEGORY.BEST_OVERALL_BROKER
        },
        {
          Id: `Axi-${guid()}`,
          Name: COMPANY_NAME.AXI,
          LogoUrl: BRAND_LOGOS.AXI,
          WinningCategory: AWARD_CATEGORY.MOST_INNOVATIVE_BROKER
        },
        {
          Id: `Deriv-${guid()}`,
          Name: COMPANY_NAME.DERIV,
          LogoUrl: BRAND_LOGOS.DERIV,
          WinningCategory: AWARD_CATEGORY.BEST_TRADING_CONDITIONS
        }
      ]
    }
  },
  B2B: {
    InstitutionalTrading: {
      Brands: [
        {
          Id: `AxiPrime-${guid()}`,
          Name: COMPANY_NAME.AXI_PRIME,
          LogoUrl: BRAND_LOGOS.AXI_PRIME,
          WinningCategory: AWARD_CATEGORY.BEST_EXECUTION_BROKER
        },
        {
          Id: `OnePrime-${guid()}`,
          Name: COMPANY_NAME.ONE_PRIME,
          LogoUrl: BRAND_LOGOS.ONE_PRIME,
          WinningCategory: AWARD_CATEGORY.BEST_TRADING_INFRASTRUCTURE_PROVIDER
        },
        {
          Id: `CMCConnect-${guid()}`,
          Name: COMPANY_NAME.CMC_CONNECT,
          LogoUrl: BRAND_LOGOS.CMC_CONNECT,
          WinningCategory: AWARD_CATEGORY.BEST_INSTITUTIONAL_LIQUIDITY_SERVICE
        }
      ]
    },
    TechForBrokers: {
      Brands: [
        {
          Id: `Axcera-${guid()}`,
          Name: COMPANY_NAME.AXCERA,
          LogoUrl: BRAND_LOGOS.AXCERA,
          WinningCategory: AWARD_CATEGORY.BEST_PROP_TRADING_TECHNOLOGY_PROVIDER
        },
        {
          Id: `oneZero-${guid()}`,
          Name: COMPANY_NAME.ONE_ZERO,
          LogoUrl: BRAND_LOGOS.ONE_ZERO,
          WinningCategory: AWARD_CATEGORY.BEST_LIQUIDITY_POOL_AGGREGATOR
        },
        {
          Id: `Centroid-${guid()}`,
          Name: COMPANY_NAME.CENTROID,
          LogoUrl: BRAND_LOGOS.CENTROID,
          WinningCategory: AWARD_CATEGORY.BEST_MULTI_ASSET_TRADING_TECHNOLOGY
        },
        {
          Id: `Quadcode-${guid()}`,
          Name: COMPANY_NAME.QUADCODE,
          LogoUrl: BRAND_LOGOS.QUADCODE,
          WinningCategory: AWARD_CATEGORY.BEST_WHITE_LABEL_SOLUTION_FOR_BROKERS
        },
        {
          Id: `FYNXT-${guid()}`,
          Name: COMPANY_NAME.FYNXT,
          LogoUrl: BRAND_LOGOS.FYNXT,
          WinningCategory: AWARD_CATEGORY.BEST_BROKER_INFRASTRUCTURE_PROVIDER
        },
        {
          Id: `Paytiko-${guid()}`,
          Name: COMPANY_NAME.PAYTIKO,
          LogoUrl: BRAND_LOGOS.PAYTIKO,
          WinningCategory: AWARD_CATEGORY.MOST_INNOVATIVE_PAYMENT_ORCHESTRATOR
        },
        {
          Id: `YourBourse-${guid()}`,
          Name: COMPANY_NAME.YOUR_BOURSE,
          LogoUrl: BRAND_LOGOS.YOUR_BOURSE,
          WinningCategory: AWARD_CATEGORY.BEST_CONNECTIVITY_TECHNOLOGY
        }
      ]
    }
  }
}
